const resource = {
  "general.save": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"保存"}},
  "general.update": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"保存"}},
  "general.edit": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"編輯"}},
  "general.delete": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"刪除"}},
  "general.create": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"創建"}},
  "general.register": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"創建"}},
  "general.search": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"搜索"}},
  "general.submit": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"提交"}},
  "general.none": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"無"}},
  "general.cancel": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"取消"}},
  "general.close": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"關閉"}},
  "general.all": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"全部"}},
  "general.confirm": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"確認"}},
  "general.error_reload": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"發生錯誤。請刷新頁面。"}},
  "general.error_retry": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"發生錯誤。請重試。"}},
  "general.error": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"發生錯誤。"}},
  "general.name": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"姓名"}},
  "general.phone": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"電話號碼"}},
  "general.skip": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"跳過"}},
  "general.next": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"下一步"}},
  "general.done": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"完成"}},
  "date.weekday.0": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"日"}},
  "date.weekday.1": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"一"}},
  "date.weekday.2": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"二"}},
  "date.weekday.3": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"三"}},
  "date.weekday.4": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"四"}},
  "date.weekday.5": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"五"}},
  "date.weekday.6": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"六"}},
  "date.month.0": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"1月"}},
  "date.month.1": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"2月"}},
  "date.month.2": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"3月"}},
  "date.month.3": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"4月"}},
  "date.month.4": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"5月"}},
  "date.month.5": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"6月"}},
  "date.month.6": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"7月"}},
  "date.month.7": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"8月"}},
  "date.month.8": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"9月"}},
  "date.month.9": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"10月"}},
  "date.month.10": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"11月"}},
  "date.month.11": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"12月"}},
  "date.today": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"今天"}},
  "date.day_short": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"日"}},
  "date.week_short": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"周"}},
  "date.month_short": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"月"}},
  "date.year_short": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"年"}},
  "date.full_datetime": {"t":0,"b":{"t":2,"i":[{"t":4,"k":"year"},{"t":3,"v":"年"},{"t":4,"k":"month"},{"t":4,"k":"day"},{"t":3,"v":"日("},{"t":4,"k":"weekday"},{"t":3,"v":") "},{"t":4,"k":"time"}]}},
  "date.short_date": {"t":0,"b":{"t":2,"i":[{"t":4,"k":"month"},{"t":4,"k":"day"},{"t":3,"v":"日"},{"t":4,"k":"weekday"}]}},
  "user.profile": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"個人資料"}},
  "user.employee_id": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"員工編號"}},
  "user.furigana": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"假名注音"}},
  "user.preferred_branch": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"常用門店"}},
  "user.preferred_branch_tooltip": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"選擇門店時，常用門店將始終顯示在列表頂部。"}},
  "user.language": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"語言"}},
  "user.default_language": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"預設"}},
  "user.smarthr_api_token": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"SmartHR 出勤 API 令牌"}},
  "user.smarthr_api_token_tooltip": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"要連接到 SmartHR 出勤系統，需要在 SmartHR 出勤側生成 API 令牌並在此處註冊。"}},
  "user.api_token_not_set": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"未設置 API 令牌。"}},
  "user.api_token_set": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"已設置 API 令牌。"}},
  "user.email": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"郵箱地址"}},
  "user.no_login_email": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"無登錄郵箱"}},
  "user.change_email": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"更改郵箱"}},
  "user.password": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"密碼"}},
  "user.password_already_set": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"密碼已設置。"}},
  "user.password_not_set": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"未設置密碼。"}},
  "user.change_password": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"更改密碼"}},
  "user.create_password": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"創建密碼"}},
  "user.new_api_token": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"新的 API 令牌"}},
  "dash.title_default": {"t":0,"b":{"t":1,"c":[{"t":2,"i":[{"t":3}],"s":"oplus"},{"t":2,"i":[{"t":3}],"s":"免費排班管理"}]}},
  "dash.meta_description": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"免費排班管理"}},
  "dash.nav.master": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"主頁"}},
  "dash.nav.profile": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"編輯資料"}},
  "dash.nav.notifications": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"通知設置"}},
  "dash.nav.api": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"API 集成"}},
  "dash.nav.referral": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"推薦活動"}},
  "dash.nav.logout": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"退出登錄"}},
  "dash.nav.onboarding": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"入門指引"}},
  "dash.nav.charts": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"圖表"}},
  "dash.nav.staff": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"員工管理"}},
  "dash.nav.shift": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"排班管理"}},
  "dash.nav.roles": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"崗位管理"}},
  "dash.nav.attendance": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"出勤管理"}},
  "dash.nav.pto": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"帶薪休假管理"}},
  "dash.nav.requests": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"申請/審批"}},
  "dash.nav.smarthr": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"員工頁面"}},
  "dash.nav.plan": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"計劃管理"}},
  "dash.nav.announce": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"公告"}},
  "dash.nav.settings": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"設置"}},
  "dash.nav.qr_punch": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"打卡二維碼"}},
  "dash.nav.branch_punch": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"門店打卡"}},
  "dash.nav.shift_submit": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"提交班次"}},
  "dash.nav.timecard": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"打卡記錄"}},
  "dash.nav.board": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"公告板"}},
  "dash.nav.upgrade": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"升級"}},
  "dash.nav.help": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"幫助"}},
  "dash.nav.news": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"最新動態"}},
  "dash.nav.contact": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"聯繫我們"}},
  "dash.nav.demo_tour": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"預約演示"}},
  "dash.nav.basics": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"基本操作"}},
  "dash.nav.feedback": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"意見反饋"}},
  "dash.slot.label_placeholder": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"可選，例如：收銀、清潔"}},
  "dash.slot.label": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"標籤"}},
  "dash.slot.from": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"開始"}},
  "dash.slot.to": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"結束"}},
  "dash.slot.break_placeholder": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"可選：0.25、0.5、0.75、1.0"}},
  "dash.slot.break": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"休息時間"}},
  "dash.slot.wage": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"時薪"}},
  "dash.slot.help": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"支援"}},
  "dash.slot.section": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"分區"}},
  "dash.slot.shift_request": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"排班申請"}},
  "dash.slot.quick_add": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"快速添加"}},
  "dash.slot.pto": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"帶薪休假"}},
  "dash.slot.half_pto": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"半天帶薪休假"}},
  "dash.slot.legal_holiday": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"法定休息日"}},
  "dash.slot.non_legal_holiday": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"非法定休息日"}},
  "dash.slot.pattern": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"模式"}},
  "dash.slot.confirm": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"確認"}},
  "dash.slot.weekly_repeat": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"每周重複"}},
  "dash.slot.memo": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"備註"}},
  "dash.slot.activity": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"動態"}},
  "dash.slot.comment_placeholder": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"評論"}},
  "dash.slot.notify_email": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"郵件通知"}},
  "dash.slot.break_checkbox": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"休息"}},
  "dash.section.roles": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"崗位分區"}},
  "dash.upgrade.required": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"需要升級"}},
  "dash.upgrade.description": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"升級到 Pro 套餐即可使用此功能"}},
  "dash.upgrade.details": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"查看詳情"}},
  "dash.repeat.delete_title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"刪除重複班次"}},
  "dash.repeat.delete_all": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"刪除此班次及之後所有班次"}},
  "dash.repeat.delete_only": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"僅刪除此班次"}},
  "dash.repeat.confirm": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"確認"}},
  "dash.csv.title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"CSV 崗位導入"}},
  "dash.csv.description": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"通過 CSV 文件註冊崗位並設置所需人數"}},
  "dash.csv.sample": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"CSV 文件示例"}},
  "dash.csv.remove_dates": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"移除列出的日期"}},
  "dash.csv.import": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"導入"}},
  "dash.ie.title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"致 Internet Explorer 用戶"}},
  "dash.ie.message_1": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"您使用的瀏覽器"}},
  "dash.ie.message_2": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Internet Explorer，不受支持。"}},
  "dash.ie.use_these": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"請使用以下瀏覽器之一。"}},
  "dash.ie.install": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"安裝並使用"}},
  "notif.error": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"無法編輯通知設置。"}},
  "notif.col.shift_comment": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"班次評論"}},
  "notif.col.shift_ask": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"排班申請"}},
  "notif.col.shift_reply": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"排班回復"}},
  "notif.col.pto": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"帶薪休假審批/拒絕"}},
  "notif.col.overtime": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"加班提醒"}},
  "notif.all_read": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"已全部處理完畢。"}},
  "notif.mark_all_read_tooltip": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"全部標記為已讀"}},
  "notif.title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"通知"}},
  "notif.board_comment": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"公告板評論"}},
  "notif.shift_comment": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"班次評論"}},
  "api.title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"API 使用指南"}},
  "api.token_auth_title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"令牌認證"}},
  "api.header_required_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"所有請求都需要以下請求頭"}},
  "api.token_instructions": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"如果您沒有令牌，請使用下方按鈕生成。您也可以重新生成令牌，但這樣會使之前的令牌失效。"}},
  "api.user_id_label": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"用戶 ID"}},
  "api.token_label": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"令牌"}},
  "api.issue": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"生成"}},
  "api.endpoint": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"接口地址"}},
  "api.request_params": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"請求參數"}},
  "api.response_fields": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"響應字段"}},
  "api.curl_sample": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"CURL 請求示例"}},
  "api.required": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"必填"}},
  "api.optional": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"可選"}},
  "api.pagination_info": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"分頁信息"}},
  "api.field.company_id": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"公司 ID"}},
  "api.field.company_name": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"公司名稱"}},
  "api.field.branch_id": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"門店 ID"}},
  "api.field.branch_name": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"門店名稱"}},
  "api.field.employee_id": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"員工編號"}},
  "api.field.employee_ids_list": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"員工編號列表"}},
  "api.field.owner_ids_list": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"所有者 ID 列表"}},
  "api.field.name": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"姓名"}},
  "api.field.email": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"郵箱"}},
  "api.field.cursor": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"用於獲取下一頁的游標"}},
  "api.field.pagination_done": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"表示分頁是否已結束的標誌"}},
  "api.shift.title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"排班 API"}},
  "api.shift.description": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"獲取指定時間段內的排班"}},
  "api.shift.from_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"要獲取的排班期間的開始日期，格式：YYYY-MM-DD"}},
  "api.shift.to_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"要獲取的排班期間的結束日期，格式：YYYY-MM-DD"}},
  "api.shift.locked_only_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"設為 true 時僅返回已確定的班次"}},
  "api.shift.id_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"班次 ID"}},
  "api.shift.from_time_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"班次開始時間"}},
  "api.shift.to_time_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"班次結束時間"}},
  "api.shift.type_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"類型 (0: 普通, 1: O, 2: X, 3: 帶薪休假, 4: 休息, 5: 半天帶薪休假, 6: 法定休息日, 7: 非法定休息日, 100: (KOT) 帶薪休假, 101: (KOT) 上午休, 102: (KOT) 下午休, 103: (KOT) 按小時休假)"}},
  "api.shift.role_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"崗位名稱"}},
  "api.shift.store_id_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"門店 ID"}},
  "api.shift.sections_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"分區班次列表"}},
  "api.shift.is_off_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"該班次是否為休息日，或該分區是否為休息時段"}},
  "api.shift.locked_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"已確定"}},
  "api.employee.title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"員工 API"}},
  "api.employee.description": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"獲取員工列表"}},
  "api.employee.companies_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"各公司的信息"}},
  "api.employee.company_employee_id_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"公司內的員工編號"}},
  "api.employee.linked_mf_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"與 MF 關聯"}},
  "api.branch.title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"門店 API"}},
  "api.branch.description": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"獲取門店信息"}},
  "api.branch_list.title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"門店列表 API"}},
  "api.branch_list.description": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"獲取指定公司的門店列表"}},
  "api.branch_list.user_or_group_required": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"userID 和 groupID 必須提供其中一個"}},
  "api.branch_list.data_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"門店列表"}},
  "api.token_upload.title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"上傳外部集成令牌"}},
  "api.user_bulk_import.title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"批量導入用戶"}},
  "api.user_bulk_import.employee_link_id_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"員工關聯 ID"}},
  "api.user_bulk_import.birth_date_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"出生日期"}},
  "api.user_bulk_import.branch_id_or_code_required": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"branch_id 和 branch_code 必須提供其中一個"}},
  "api.user_bulk_import.branch_id_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"門店 ID"}},
  "api.user_bulk_import.branch_code_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"門店關聯 ID"}},
  "api.user_bulk_import.tags_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"標籤"}},
  "api.user_bulk_import.transport_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"交通補貼"}},
  "api.user_bulk_import.max_month_workdays_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"每月最大出勤天數"}},
  "api.user_bulk_import.min_week_labor_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"每周最低勞動時間（分鐘）"}},
  "api.user_bulk_import.max_week_labor_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"每周最大勞動時間（分鐘）"}},
  "api.user_bulk_import.min_month_labor_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"每月最低勞動時間（分鐘）"}},
  "api.user_bulk_import.max_month_labor_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"每月最大勞動時間（分鐘）"}},
  "api.branch_bulk_import.title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"批量導入門店"}},
  "api.branch_bulk_import.name_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"門店名稱"}},
  "api.branch_bulk_import.address_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"門店地址"}},
  "api.group_users.title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"群組用戶列表"}},
  "api.group_users.id_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"群組用戶 ID"}},
  "api.group_users.is_owner_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"表示該用戶是否為該群組的所有者。"}},
  "api.group_users_update.title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"更新群組用戶"}},
  "api.group_users_update.edit_all_branches_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"將群組員工編號應用到所有門店"}},
  "api.group_users_delete.title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"刪除群組用戶"}},
  "referral.header": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"每次推薦最高可獲得 ¥50,000！"}},
  "referral.subtitle_line1": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"您身邊有經營或管理企業的朋友嗎？"}},
  "referral.subtitle_line2": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"請將 oplus 推薦給他們 - 如果被推薦的公司簽約成功，我們將贈送您喜歡的禮品卡。"}},
  "referral.step1_label": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"步驟 1"}},
  "referral.step1_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"推薦您認為可能從 oplus 中獲益的公司的老闆或負責人。"}},
  "referral.step2_label": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"步驟 2"}},
  "referral.step2_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"被推薦人註冊 oplus 付費套餐。"}},
  "referral.step3_label": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"步驟 3"}},
  "referral.step3_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"作為對您推薦的感謝，我們將贈送您禮品卡。"}},
  "referral.rewards_title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"已獲得的獎勵"}},
  "referral.total_earned_label": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"目前已獲得總額： "}},
  "referral.how_it_works_title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"*這是如何運作的？"}},
  "referral.how_it_works_intro": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"您推薦的公司規模越大，對方註冊付費套餐時您獲得的獎勵就越大。"}},
  "referral.example_label": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"示例："}},
  "referral.how_it_works_example": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"如果一家擁有 250 名員工的公司通過您的推薦鏈接註冊了 oplus 的付費套餐 - Pro 套餐、Pro+ 出勤套餐、自動排班生成功能或 oplus chat - 您將獲得一張 ¥10,000 的禮品卡！"}},
  "referral.how_it_works_note": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"您可以推薦任意數量的公司。推薦越多，獎勵越多。"}},
  "referral.table.company_size": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"公司規模（員工人數）"}},
  "referral.table.gift_card_amount": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"禮品卡獎勵金額"}},
  "referral.tips_title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"充分利用 oplus 推薦計劃的小貼士："}},
  "referral.tips.share_link": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"在公司網站或社交媒體上分享您的推薦鏈接。"}},
  "referral.tips.invite": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"發送推薦鏈接，或邀請合作夥伴、同事等商業聯繫人。"}},
  "referral.tips.introduce_features": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"向他們介紹 oplus 的功能和優勢。"}},
  "referral.tips.visibility": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"使用醒目的設計或文字讓您的推薦鏈接更突出。"}},
  "referral.tips.track_progress": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"隨時關注您的推薦數量和獎勵進度。"}},
  "referral.share.title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"請將 oplus 推薦給您的商業夥伴和聯繫人。"}},
  "referral.share.line_title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"直接通過 LINE 分享"}},
  "referral.share.line_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"（打開 LINE 將邀請鏈接發送給朋友或同事）"}},
  "referral.share.line_message": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"您好！讓我們用 oplus 輕鬆管理公司的排班吧。請點擊下方鏈接！"}},
  "referral.share.line_button": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"通過 LINE 分享"}},
  "referral.share.link_title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"您的推薦鏈接"}},
  "referral.share.link_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"（將此鏈接粘貼到聊天、社交媒體或郵件中以邀請他人使用 oplus）"}},
  "referral.share.copy_button": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"複製鏈接"}},
  "referral.history.title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"推薦歷史"}},
  "referral.history.company_name": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"公司名稱"}},
  "referral.history.status": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"狀態"}},
  "referral.history.reward": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"獎勵"}},
  "referral.history.accepted": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"已通過"}},
  "referral.history.pending_suffix": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"（待處理）"}},
  "referral.history.paid_suffix": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"（已發送）"}},
  "referral.history.pending": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"待處理"}},
  "referral.history.empty_title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"暫無推薦記錄。"}},
  "referral.history.empty_desc": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"不妨發送您的鏈接或邀請他人加入 oplus？- 每成功推薦一次，最高可獲得 ¥50,000 的禮品卡！"}},
  "logout.confirm_message": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"確定要退出登錄嗎？"}},
  "logout.error": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"退出登錄失敗。"}},
  "branch_menu.search_placeholder": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"門店名稱"}},
  "branch_menu.selected_branch": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"當前選中的門店"}},
  "punch_qr.access_required": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"正在啟動二維碼掃描器，請允許訪問攝像頭。"}},
  "punch_qr.hold_camera": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"請將門店打卡二維碼對準攝像頭。"}},
  "punch_qr.title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"打卡二維碼"}},
  "punch_qr.description_line1": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"在員工頁面點擊“打卡”以啟動攝像頭。"}},
  "punch_qr.description_line2": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"將攝像頭對準此二維碼即可打卡。"}},
  "shift.aim_text.title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"■致在駐留期間於其他公司兼職或打工的人員"}},
  "shift.aim_text.body": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"按照入住時的承諾，請合併考慮您在運動員村的工作時間與在其他工作的工作時間，確保每周總工作時間不超過 40 小時，並據此申請休息日（不在運動員村工作的日子）。"}},
  "shift.aim_text.note1": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"*4 月至 6 月無需填寫班次* "}},
  "shift.aim_text.note2": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"*抱歉給您帶來不便，請使用下方“＜ 今天 ＞”右側的“＞”按鈕跳轉至 7 月*"}},
  "shift.staff_lock_notice": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"班次已確定至 %s。如需更改已確定提交的班次，請直接聯繫您的排班管理員。"}},
  "shift.staff_lock_alert": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"班次已確定至“%s”。如需更改已確定提交的班次，請直接聯繫您的排班管理員。"}},
  "shift.col_date": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"日期"}},
  "shift.col_time": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"時間"}},
  "shift.col_create": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"創建"}},
  "shift.add_disabled_tooltip": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"因已滿足所需人數，此項已禁用"}},
  "shift.template_label": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"模板"}},
  "shift.role_label": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"崗位"}},
  "shift.export_label": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"導出"}},
  "shift.ics_tooltip": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"將下載一個 ICS 文件，請使用您的日曆應用打開。"}},
  "shift.repeat_request_error": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"無法在重複班次上提交排班申請。請改為創建新班次。"}},
  "slot_modal.roles_label": {"t":0,"b":{"t":2,"i":[{"t":3,"v":"崗位（"},{"t":4,"k":"count"},{"t":3,"v":"）"}]}},
  "slot_modal.no_roles": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"暫無崗位"}},
  "dash.label.pro_plus_attendance": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Pro+ 出勤"}},
  "dash.label.auto": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"自動"}},
  "dash.label.add_suffix": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":" 添加"}},
  "dash.label.none_suffix": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":" 無"}},
  "shift.created_label": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"創建： "}},
  "shift.edited_label": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"編輯： "}},
  "shift.new_shift_badge": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"新班次"}},
  "shift.repeat_staff_request_block": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"如果已設置排班申請，則員工提交的班次無法轉為重複班次。"}},
  "shift.log_created": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":" 創建了該班次。"}},
  "shift.log_created_with_time": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"已為 %s 創建班次。"}},
  "shift.log_modified": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"從 %s 更改為 %s。"}},
  "shift.log_locked": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":" 確定了該班次。"}},
  "shift.log_unlocked": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":" 取消確定了該班次。"}},
  "shift.log_asked": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":" 申請了該班次。"}},
  "shift.log_accepted": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":" 批准了該班次。"}},
  "shift.log_rejected": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":" 拒絕了該班次。"}},
  "shift.log_copied": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"該班次已被複制。"}},
  "shift.log_moved": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"該班次已被移動。"}},
  "shift.comment_added_prefix": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"由於添加了評論，"}},
  "shift.repeat_unlink_confirm": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"%s該重複班次將被取消關聯並變更為新班次，確定繼續嗎？"}},
  "shift.repeat_apply_all_confirm": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"這將應用於所有相關的重複班次，確定繼續嗎？"}},
  "shift.branch_punch_unsupported_alert": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"無法在“oplus 排班管理”中掃描門店打卡二維碼，請改用“oplus打卡應用”。\n\n請在 AppStore 或 Google Play 商店中搜索“打刻”並安裝打卡應用。"}},
  "shift.monthly_vacation_exceeded": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"已超出每月可申請的休息天數上限。"}},
  "shift.template_edit_title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"編輯模板"}},
  "shift.template_create_title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"創建模板"}},
  "shift.minutes_suffix": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":" 分鐘"}},
  "shift.calendar_view": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"日曆"}},
  "shift.list_view": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"列表"}},
  "shift.no_shifts": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"暫無班次"}},
  "shift.staff_requested_off_label": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"請假申請"}},
  "shift.kot_pto_label": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"KOT帶薪休假"}},
  "shift.kot_half_pto_am_label": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"KOT上午休"}},
  "shift.kot_half_pto_pm_label": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"KOT下午休"}},
  "date_nav.year_range": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"1月1日 ~ 12月31日"}},
  "date_nav.year_label": {"t":0,"b":{"t":2,"i":[{"t":4,"k":"year"},{"t":3,"v":"年"}]}},
  "request.tab_individual": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"個人申請"}},
  "request.tab_management": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"申請/審批管理"}},
  "request.confirm_action": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"確定要%s嗎？"}},
  "request.confirm_undo": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"確定要撤銷嗎？"}},
  "request.oplus_support": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"oplus 客服"}},
  "request.undo": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"撤銷"}},
  "request.status_header_manager": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"處理"}},
  "request.status_header_staff": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"狀態"}},
  "request.pending_title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"待處理申請"}},
  "request.col_date": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"日期"}},
  "request.col_staff": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"員工"}},
  "request.col_category": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"類別"}},
  "request.col_note": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"備註"}},
  "request.col_manager": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"管理者"}},
  "request.empty_title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"暫無申請"}},
  "request.empty_subtitle": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"請使用上方的創建按鈕提交申請。"}},
  "request.history_title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"申請歷史"}},
  "request.col_result": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"結果"}},
  "request.select_category_alert": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"請選擇類別。"}},
  "request.select_category_placeholder": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"請選擇類別"}},
  "request.confirm_delete": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"確定要刪除嗎？"}},
  "request.modal_title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"申請"}},
  "request.category.1": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"帶薪休假"}},
  "request.category.2": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"半天帶薪休假"}},
  "request.category.3": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"無薪休假"}},
  "request.category.4": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"早退"}},
  "request.category.5": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"遲到"}},
  "request.category.6": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"提前上班"}},
  "request.category.7": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"加班/遲到"}},
  "request.category.8": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"排班申請"}},
  "request.category.9": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"排班變更"}},
  "request.category.10": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"其他"}},
  "request.status.1": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"待處理"}},
  "request.status.2": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"已批准"}},
  "request.status.3": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"已拒絕"}},
  "request.status.4": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"已取消"}},
  "pto.status_title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"使用狀況"}},
  "pto.col_acquired_date": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"獲得日期"}},
  "pto.col_held_days": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"持有天數"}},
  "pto.col_used_days": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"已使用天數"}},
  "pto.col_expired_days": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"已過期天數"}},
  "pto.col_remaining_days": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"剩餘天數"}},
  "pto.empty_title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"暫無帶薪休假信息。"}},
  "pto.empty_subtitle": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"%s 當前沒有可申請的帶薪休假。"}},
  "pto.over_limit_notice": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"帶薪休假使用量已超出持有天數。"}},
  "pto.request_result_title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"申請結果"}},
  "pto.request_btn": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"申請帶薪休假"}},
  "pto.col_approval": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"審批"}},
  "pto.col_branch": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"門店名稱"}},
  "pto.col_approver": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"審批人"}},
  "pto.approved": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"已批准"}},
  "pto.empty_history_title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"暫無申請歷史。"}},
  "pto.empty_history_subtitle": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"%s 沒有已批准或已拒絕的帶薪休假記錄。"}},
  "pto.delete_other_branch_alert": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"無法刪除在其他門店已批准或已拒絕的帶薪休假。請切換到該門店后再刪除。"}},
  "pto.delete_confirm": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"確定要刪除嗎？"}},
  "pto.desired_date": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"期望日期"}},
  "date.full_date": {"t":0,"b":{"t":2,"i":[{"t":4,"k":"year"},{"t":3,"v":"年"},{"t":4,"k":"month"},{"t":4,"k":"day"},{"t":3,"v":"日 ("},{"t":4,"k":"weekday"},{"t":3,"v":")"}]}},
  "date.numeric_short_date": {"t":0,"b":{"t":2,"i":[{"t":4,"k":"month"},{"t":3,"v":"/"},{"t":4,"k":"day"},{"t":3,"v":" ("},{"t":4,"k":"weekday"},{"t":3,"v":")"}]}},
  "timecard.greeting": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"%s"}},
  "timecard.already_punched_in": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"您已打卡上班。"}},
  "timecard.already_punched_out": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"您已打卡下班。"}},
  "timecard.punch_in": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"上班打卡"}},
  "timecard.punch_out": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"下班打卡"}},
  "timecard.rest_start": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"開始休息"}},
  "timecard.rest_end": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"結束休息"}},
  "timecard.geolocation_loading": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"正在獲取位置信息，請稍候。"}},
  "timecard.labor_col": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"工時"}},
  "timecard.missing_punch": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"缺勤打卡"}},
  "timecard.missing_punch_header": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"以下門店檢測到缺失打卡記錄：\n"}},
  "timecard.missing_punch_line": {"t":0,"b":{"t":2,"i":[{"t":3,"v":"\n門店："},{"t":4,"k":"name"},{"t":3,"v":"\n打卡時間："},{"t":4,"k":"time"},{"t":3,"v":"\n"}]}},
  "timecard.auto_delete_message": {"t":0,"b":{"t":2,"i":[{"t":3,"v":"由於上班與下班打卡之間的時間不超過 "},{"t":4,"k":"minutes"},{"t":3,"v":" 分鐘，該打卡記錄已被刪除。"}]}},
  "board.intro_message": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"這是用於向所有員工發送郵件的功能，可用於發布報告、協調排班等。"}},
  "board.title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"公告板"}},
  "board.message_modal_title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"公告板消息"}},
  "board.send_all_branches": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"發送至所有門店"}},
  "board.notify_to": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"通知對象"}},
  "board.everyone": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"所有人"}},
  "board.role_shift_leader": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"排班編輯者"}},
  "board.role_staff": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"員工"}},
  "board.message_label": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"消息"}},
  "board.edited_suffix": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"（已編輯）"}},
  "board.comments_label": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"評論"}},
  "board.confirm_delete_message": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"確定要刪除此消息嗎？"}},
  "board.original_image_size": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"原始圖片大小"}},
  "board.deleted_reload_alert": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"該公告板帖子已被刪除，請刷新頁面。"}},
  "feedback.description": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"為了幫助我們改進服務，請分享您的反饋。我們會認真審閱所有反饋，並用於改進今後的服務。"}},
  "feedback.category_opinion": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"意見反饋/諮詢"}},
  "feedback.category_materials": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"申請資料"}},
  "feedback.category_demo": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"申請演示"}},
  "feedback.category_bug": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"故障報告"}},
  "feedback.contact_intro_line1": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"如有其他問題或需要幫助，"}},
  "feedback.contact_intro_line2": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"請在此聯繫我們。"}},
  "feedback.phone_contact_title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"電話聯繫"}},
  "feedback.business_hours": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"工作日 9:00 - 18:00"}},
  "profile_photo.title": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"個人頭像"}},
  "profile_photo.import": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"上傳個人頭像"}},
  "profile_photo.browse": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"瀏覽"}},
  "profile_photo.select": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"選擇文件"}},
  "profile_photo.drag": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"把文件拖拽到此區域"}},
  "profile_photo.upload": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"上傳文件"}},
  "profile_photo.error_format": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"不是影像檔，目前只支援jpg/ jpeg/ png。"}},
  "profile_photo.error_size": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"檔案太大，請上傳10MB以下的檔案。"}}
}
export default resource